<script setup lang="ts">
import { useCategoryStore } from '@/store/category.store';
import { useProductStore } from '@/store/product.store';
import caterogierComponent from './caterogierComponent.vue';
import { useQuery } from '@tanstack/vue-query';
import { ref, toRaw, watchEffect, useTemplateRef, computed } from 'vue';
import { category_product } from '@/refs/product.refs';
const categoryStore = useCategoryStore();
const productStore = useProductStore();
// -------------------------------
// 🔹 Récupération des catégories avec Vue Query
// -------------------------------
const {
  data: dataGetCategories,
  isLoading: isLoadingGetCategories,
  isError: isErrorGetCategories,
  refetch: refectGetCategories,
} = useQuery({
  queryKey: ['GetCategories'],
  queryFn: () => categoryStore.getCategory(),
});

const {
  data: dataGetProduct,
  isLoading: isLoadingGetProduct,
  isError: isErrorGetProduct,
  refetch: refectGetProduct,
} = useQuery({
  queryKey: ['GetProduct'],
  queryFn: () => productStore.getProduct(),
});
</script>

<template>
  <div class="h-[140px] overflow-hidden">
    <div v-if="isLoadingGetCategories" class="">
      <div class="flex w-full flex-col items-center gap-[16px]">
        <div
          v-for="value in 3"
          :key="value"
          class="flex h-full w-full animate-pulse flex-col gap-[8px]"
        >
          <div
            class="flex w-full flex-row items-center justify-between gap-[16px]"
          >
            <div class="bg-soft-gray h-[100px] w-full rounded-[10px]" />
            <div
              class="bg-soft-gray aspect-square size-[100px] rounded-[10px]"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-else class="">
      <div class="scrollToSection">
        <div>
          <div class="px-[16px]" v-if="!isLoadingGetProduct">
            <p class="h-2"></p>
            <h3
              class="text-14px text-grand-text font-tt-semiBold-Normal leading-normal"
            >
              {{
                category_product.length > 0
                  ? dataGetCategories?.data.find(
                      (cat: any) => cat.id === category_product[0],
                    )?.designation
                  : 'Ajouter une catégorie'
              }}
            </h3>

            <p class="h-2"></p>
          </div>
          <p v-else></p>
        </div>

        <div class="px-5">
          <caterogierComponent />
        </div>
      </div>
      <div>
        <div v-if="!isLoadingGetProduct" class="bg-soft-gray h-1 w-full" />

        <div v-else class="">
          <div
            class="flex w-full animate-pulse flex-col items-center gap-[16px] px-[16px]"
          >
            <div
              v-for="value in 3"
              :key="value"
              class="flex h-full w-full flex-col gap-[8px]"
            >
              <div
                class="flex w-full flex-row items-center justify-between gap-[16px]"
              >
                <div class="bg-soft-gray h-[100px] w-full rounded-[10px]" />
                <div
                  class="bg-soft-gray aspect-square size-[100px] rounded-[10px]"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
